"use client";

import { useState } from "react";

import { CreatePostForm } from "@/components/posts/create-post-form";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useStore } from "@/store/store";

type EditPostModelProps = {
  post: PostsEntity;
  showEditDialog: boolean;
  setShowEditDialog: (open: boolean) => void;
};

function EditPostModel({
  post,
  showEditDialog,
  setShowEditDialog,
}: EditPostModelProps) {
  const [showConfirmClose, setShowConfirmClose] = useState(false);
  const { setFeeling, setFiles } = useStore();

  const handleCloseRequest = (open: boolean) => {
    if (!open) {
      setShowConfirmClose(true);
    }
 else {
      setShowEditDialog(true);
    }
  };

  const discardChanges = () => {
    setShowEditDialog(false);
    setShowConfirmClose(false);
    setFiles([]);
    setFeeling(null);
  };

  return (
    <>
      <Dialog open={showEditDialog} onOpenChange={handleCloseRequest}>
        <DialogContent
          onPointerDownOutside={e => e.preventDefault()}
          className="max-w-[330px] md:max-w-xl max-h-[450px] p-0 overflow-scroll"
        >
          <DialogTitle className="sr-only">Edit Post Form</DialogTitle>
          <div>
            <CreatePostForm
              isEdit={true}
              post={post}
              setShowEditDialog={setShowEditDialog}
            />
          </div>
        </DialogContent>
      </Dialog>

      <AlertDialog open={showConfirmClose} onOpenChange={setShowConfirmClose}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Discard changes?</AlertDialogTitle>
            <AlertDialogDescription>
              If you close now, all your edits will be lost.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel
              onClick={() => setShowConfirmClose(false)}
              className="rounded-lg"
            >
              Continue editing
            </AlertDialogCancel>
            <AlertDialogAction
              onClick={discardChanges}
              className="bg-red-500 text-white hover:bg-red-600 rounded-lg"
            >
              Discard
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}

export default EditPostModel;
